<template>
  <suc-date-time-field
    :title="$t('pages.planing-team.workshift.end_date')"
    v-bind="$attrs"
    v-on="$listeners"
  ></suc-date-time-field>
</template>

<script>
import { SucDateTimeField } from "@/components/form";

export default {
  components: {
    SucDateTimeField,
  },
};
</script>

<style></style>
